module.exports = __webpack_public_path__ + "img/online-store.d0ffe196.svg";